import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import SharingComponent from "./SharingComponent";
import ShareSetting from "./ShareSetting";
import axios from "axios";
import { BASE_URL, NODE_API_URL } from "../../../../env_config";
import Cookies from "js-cookie";

export const ShareStoneDetailsNew = ({ userinfo, item, show, onClose, from }) => {
    const [startDate, setStartDate] = useState(null);
    const [password, setPassword] = useState(null);
    const [openShareSetting, setOpenShareSetting] = useState(false);
    const [markupValue, setMarkupValue] = useState("");
    const [notes, setNotes] = useState(null);
    const [loader, setLoader] = useState(false);
    const [selectedValue, setSelectedValue] = React.useState("cost_price");
    const [mount, setMount] = useState(false);
    const [markupError, setMarkupError] = useState(false);
    const [data, setData] = useState(null);
    const [markupType, setMarkupType] = useState(true);
    const [phone, setPhone] = useState("");
    const [certificateEnabled, setCertificateEnabled] = useState(true);
    const [metaData,setMetaData] = useState({
        title:null,
        shape:null
    })
    const [finalPayload, setFinalPayload] = useState({
        user_id: userinfo.id,
        share_type: "link",
        share_through: "email",
        notes: null,
        entity_type: item?.diamondType,
        entity_id: item?.stockID,
        password: null,
        expiry_at: null,
        share_config: {
            show_certficate: true,
            pricing_type: "cost_price",
            markup_type: "percentage",
            markupvalue: null,
        },
    });

    const [payload, setPayload] = useState({
        user_id: userinfo.id,
        entity_type: item?.diamondType,
        entity_id: item?.stockID,
        share_config: {
            show_certficate: true,
            pricing_type: "cost_price",
            markup_type: "percentage",
            markupvalue: null,
        },
    });

    useEffect(() => {
        if (!item) return;

        const fetchData = async () => {
            try {
                setLoader(true);

                const res = await axios({
                    method: "POST",
                    url: `${NODE_API_URL}/INTL/get-pre-share-details`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token",
                        )}`,
                    },
                    data: payload,
                });

                setData(res.data.data);
                const title = `${res?.data?.data?.lab || ""} ${res?.data?.data?.shape || ""} ${
                    res?.data?.data?.carat ? res?.data?.data?.carat.toFixed(2) : ""
                } ${res?.data?.data?.color || ""} ${res?.data?.data?.clarity || ""} ${res?.data?.data?.cut || ""} ${
                    res?.data?.data?.polish || ""
                } ${res?.data?.data?.symmetry || ""} ${res?.data?.data?.fluorescence || ""}`;
                setMetaData({title:title,shape:res?.data?.data?.shape});
            } catch (error) {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    const cookies = document.cookie.split(";");

                    cookies.forEach((cookie) => {
                        if (cookie && !cookie.includes("view")) {
                            const name = cookie.split("=")[0].trim();
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    });

                    window.location.replace(`${BASE_URL}/logout`);
                } else {
                    console.log("API Error:", error);
                }
            } finally {
                setLoader(false);
            }
        };

        fetchData();
    }, [item, mount]);

    const handleBack = () => {
        setOpenShareSetting(false);
    };
    const handleNext = () => {
        if (selectedValue === "markup_price" && !markupValue) {
            setOpenShareSetting(false);
            setMarkupError("Markup value is Required");
        } else {
            setOpenShareSetting(true);
        }
    };
    useEffect(() => {
        if (markupValue) {
            setMarkupError(false);
        }
    }, [markupValue]);

    useEffect(() => {
        setPayload((prev) => ({
            ...prev,
            share_config: {
                ...prev.share_config,
                pricing_type: selectedValue,
                markupvalue:
                    selectedValue === "mark_up"
                        ? parseFloat(markupValue)
                        : null,
                markup_type: markupType ? "percentage" : "absolute", // or based on switch
            },
        }));
        setFinalPayload((prev) => ({
            ...prev,
            notes: notes,
            password: password,
            expiry_at: startDate,
            share_config: {
                ...prev.share_config,
                pricing_type: selectedValue,
                notes: notes,
                markupvalue:
                    selectedValue === "mark_up"
                        ? parseFloat(markupValue)
                        : null,
                markup_type: markupType ? "percentage" : "absolute", // or based on switch
            },
        }));
    }, [selectedValue, markupValue, password, notes]);

    const handleSend = async () => {
        console.log(finalPayload);
        try {
            setLoader(true);

            const res = await axios({
                method: "POST",
                url: `${NODE_API_URL}/INTL/share-product`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
                data: finalPayload,
            });

            console.log(res);
            // setData(res.data.data);
        } catch (error) {
            if (error?.response?.data?.message === "UnAuthorized!") {
                const cookies = document.cookie.split(";");

                cookies.forEach((cookie) => {
                    if (cookie && !cookie.includes("view")) {
                        const name = cookie.split("=")[0].trim();
                        document.cookie =
                            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                });

                window.location.replace(`${BASE_URL}/logout`);
            } else {
                console.log("API Error:", error);
            }
        } finally {
            setLoader(false);
        }
    };

    

    return (
        <div>
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                keyboard={false}
                className="share-modal"
                centered
            >
                <Modal.Body className="py-4">
                
                    {openShareSetting ? (
                        <div className="row">
                            <div className="col-12">
                                <ShareSetting
                                    markupType={markupType}
                                    setMarkupType={setMarkupType}
                                    password={password}
                                    setFinalPayload={setFinalPayload}
                                    setPassword={setPassword}
                                    setStartDate={setStartDate}
                                    startDate={startDate}
                                    mount={mount}
                                    setMount={setMount}
                                    setPayload={setPayload}
                                    onBack={handleBack}
                                    handleNext={handleNext}
                                    data={data}
                                    close={onClose}
                                    setMarkupValue={setMarkupValue}
                                    markupValue={markupValue}
                                    selectedValue={selectedValue}
                                    setSelectedValue={setSelectedValue}
                                    markupError={markupError}
                                    setCertificateEnabled={setCertificateEnabled}
                                    certificateEnabled={certificateEnabled}
                                />
                            </div>
                        </div>
                    ) : (
                        <SharingComponent
                            notes={notes}
                            openShareSetting={openShareSetting}
                            certificateEnabled={certificateEnabled}
                            loader={loader}
                            handleSend={handleSend}
                            selectedValue={selectedValue}
                            startDate={startDate}
                            setPhone={setPhone}
                            phone={phone}
                            setNotes={setNotes}
                            setOpenShareSetting={setOpenShareSetting}
                            data={data}
                            onBack={handleBack}
                            close={onClose}
                            finalPayload={finalPayload}
                            userinfo={userinfo}
                            password={password}
                            metaData={metaData}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};
